import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';

import ModalWrapper from 'components/Modals/ModalWrapper';

import { setAccount } from 'actions/app';

const SelectAccountModal = ({ dispatch, customerAccounts, selectedAccountId }) => {
  const [accountId, setAccountId] = useState(selectedAccountId);
  const intl = useIntl();
  const onAccountChange = () => {
    dispatch(setAccount(accountId));
  };

  return (
    <ModalWrapper
      title={ <h1><LocalisedMessage id="account.selection.title" /></h1> }
      className="select-account"
      disableConfirm={ !accountId }
      showCancel={ false }
      showClose={ false }
      btnConfirmTitle={ intl.formatMessage({ id: 'account.selection.continue.button' }) }
      content={ customerAccounts && customerAccounts.length > 1 && <div className="col-12">
        <div className="form-group">
          <label htmlFor="customer-accounts"><p><LocalisedMessage id="account.selection.subtitle" /></p>
            <select id="customer-accounts" value={ accountId ?? '' } onChange={ event => setAccountId(event.target.value !== '' ? parseInt(event.target.value, 10) : null) }>
              <option value="">{ intl.formatMessage({ id: 'account.selection.dropdown.placeholder' }) }</option>
              { customerAccounts && customerAccounts.map(i => <option key={ i.id } value={ i.id }>{ i.displayName }</option>) }
            </select>
          </label>
        </div>
      </div> }
      id="select-account-modal"
      onConfirm={ () => onAccountChange() }
    />
  );
};

SelectAccountModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  selectedAccountId: PropTypes.number,
  customerAccounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    displayName: PropTypes.string
  }))
};

SelectAccountModal.defaultProps = {
  customerAccounts: [],
  selectedAccountId: null,
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    form: {
      selectedAccountId
    }
  } = state;

  return {
    customerAccounts: onlineConfig && onlineConfig.customer && onlineConfig.customer.accounts,
    selectedAccountId
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectAccountModal);
